import Link from "@components/Link";
import type { ReactNode } from "react";

type CheckoutItemLinkProps = {
  children: ReactNode;
  className?: string;
  slug?: string | null;
  locale: string;
};

const CheckoutItemLink = ({
  children,
  slug,
  locale,
  ...props
}: CheckoutItemLinkProps) => {
  if (!slug) return <div {...props}>{children}</div>;

  return (
    <Link locale={locale} href={slug} {...props}>
      {children}
    </Link>
  );
};

CheckoutItemLink.displayName = "CheckoutItemLink";

export default CheckoutItemLink;
